import createElement from '../logical-components/createElement';
// Global helpers
import renderText from '../logical-components/renderText';
var translationObj = {
    date: renderText('rememberMe.info.date'),
    time: renderText('rememberMe.info.time'),
    location: renderText('rememberMe.info.location'),
    parking: renderText('rememberMe.info.parking'),
};
var cardWrapper = function (key) {
    var wrapper = createElement('div', [
        { type: 'class', value: '_msnlq-block-info' },
    ]);
    wrapper.innerHTML = "<h4> ".concat(renderText("rememberMe.info.titles.".concat(key)), " </h4> <div class='_msnlq-block-content'> </div>");
    return wrapper;
};
var standardCard = function (data, key) {
    var wrapper = cardWrapper(key);
    var content = wrapper.querySelector('._msnlq-block-content');
    content.innerHTML = "<ul>\n        ".concat(data['date'] ? "<li> <span> ".concat(translationObj.date, " </span> <span> ").concat(data['date'], " </span> </li>") : '', "\n        ").concat(data['start_time'] ? "<li> <span> ".concat(translationObj.time, " </span>  <span> ").concat(data['start_time']).concat(data['end_time'] ? " - ".concat(data['end_time']) : '', " </span> </li>") : '', "\n        ").concat(data['location'] ? "<li> <span> ".concat(translationObj.location, " </span>  <span> ").concat(data['location'], " </span> </li>") : '', "\n        ").concat(data['parking'] ? "<li> <span> ".concat(translationObj.parking, " </span>  <span> ").concat(data['parking'], " </span> </li>") : '', "\n    </ul>");
    return wrapper;
};
var flatCard = function (_a, key, buttonTitle) {
    var details = _a.details, url = _a.url;
    var wrapper = cardWrapper(key);
    var content = wrapper.querySelector('._msnlq-block-content');
    var title = createElement('p', [], details);
    content.appendChild(title);
    if (url) {
        var button = createElement('a', [
            { type: 'href', value: url },
            { type: 'target', value: '_blank' },
            { type: 'class', value: 'btn' },
        ], buttonTitle);
        content.appendChild(button);
    }
    return wrapper;
};
var rememberMeInfo = function (config, section, data) {
    var _a;
    var wrapper = createElement('div');
    var condolenceDetails = data.condolences_moment_details;
    var funeralDetails = data.funeral_moment_details;
    var streamDetails = data.livestream_details;
    var lastWishDetails = data.last_wish;
    var hasDetails = (condolenceDetails === null || condolenceDetails === void 0 ? void 0 : condolenceDetails.date) ||
        (funeralDetails === null || funeralDetails === void 0 ? void 0 : funeralDetails.date) ||
        (streamDetails === null || streamDetails === void 0 ? void 0 : streamDetails.url) ||
        (lastWishDetails === null || lastWishDetails === void 0 ? void 0 : lastWishDetails.url);
    if (((_a = section === null || section === void 0 ? void 0 : section.options) === null || _a === void 0 ? void 0 : _a.hideInfo) || !hasDetails) {
        return wrapper;
    }
    wrapper.innerHTML = "<h3> ".concat(renderText('rememberMe.info.title'), " </h3> <div class='_msnlq-info-wrap'> </div>");
    var contentWrapper = wrapper.querySelector('._msnlq-info-wrap');
    if (condolenceDetails.date) {
        contentWrapper.appendChild(standardCard(condolenceDetails, 'condolence'));
    }
    if (funeralDetails.date) {
        contentWrapper.appendChild(standardCard(funeralDetails, 'funeral'));
    }
    if (streamDetails.url) {
        contentWrapper.appendChild(flatCard(streamDetails, 'stream', 'Bekijk livestream'));
    }
    if (lastWishDetails.details || lastWishDetails.url) {
        contentWrapper.appendChild(flatCard(lastWishDetails, 'lastwishes', 'Doneer'));
    }
    return wrapper;
};
export default rememberMeInfo;
